import './Floating.e38fe3756aa257c13b0dc76deb098c1f.css';
export default {"menu":"_menu_vdo2o_1","small":"_small_vdo2o_1"};